export var CHECKBOX = "checkbox";
export var BUTTON = "button";
export var RADIO = "radio";